const ErrorMessage = ({ message }: { message: string | undefined }) => {
  return (
    <div className={"h-5"}>
      {message && <p className="text-red-500 text-xs italic">{message}</p>}
    </div>
  )
}
export default ErrorMessage
